import { render } from "./initTable.vue?vue&type=template&id=93d68a74&scoped=true"
import script from "./initTable.vue?vue&type=script&lang=js"
export * from "./initTable.vue?vue&type=script&lang=js"

import "./initTable.vue?vue&type=style&index=0&id=93d68a74&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93d68a74"]])

export default __exports__